import { resolveNexFolderNoForPoHeader, type NexFolderResolutionPoRow } from './nexFolderResolution';

/**
 * PO header + NEX line label for matched-line section headers (invoice tabs).
 */
export interface NexMatchedLinePoInfo {
    label: string | null;
    status: string | null;
}

export function formatNexMatchedLinePoLabel(
    nexLine: unknown,
    nexResponse?: NexFolderResolutionPoRow[] | null,
): NexMatchedLinePoInfo {
    if (nexLine == null || typeof nexLine !== 'object') return { label: null, status: null };
    const o = nexLine as {
        poHeaderID?: number | string;
        po_header_id?: number | string;
        lineNumber?: number | string;
        line_number?: number | string;
        lineStatus?: string;
        line_status?: string;
    };
    const poRaw = o.poHeaderID ?? o.po_header_id;
    const lineRaw = o.lineNumber ?? o.line_number;
    const poStr = poRaw !== undefined && poRaw !== null && String(poRaw).trim() !== '' ? String(poRaw).trim() : '';
    const lineStr = lineRaw !== undefined && lineRaw !== null && String(lineRaw).trim() !== '' ? String(lineRaw).trim() : '';
    const statusRaw = o.lineStatus ?? o.line_status;
    const statusStr = statusRaw != null && String(statusRaw).trim() !== '' ? String(statusRaw).trim() : '';

    let roPart = '';
    if (poStr && nexResponse?.length) {
        const poId = parseInt(poStr, 10);
        if (!Number.isNaN(poId)) {
            const folderNo = resolveNexFolderNoForPoHeader(poId, nexResponse);
            if (folderNo != null) roPart = `RO # — ${folderNo}`;
        }
    }

    const poLinePart =
        poStr && lineStr
            ? `PO / Line # — ${poStr} / L${lineStr}`
            : poStr
              ? `PO — ${poStr}`
              : lineStr
                ? `Line # — L${lineStr}`
                : '';
    const label = [roPart, poLinePart].filter(Boolean).join(' · ') || null;
    return { label, status: statusStr || null };
}
